module.exports = __webpack_public_path__ + "img/showreel2.5ccd895d.png";